export default ".custom-file-label {\n  display: inline-block;\n  padding: 10px 20px;\n  color: #888;\n}\n"